import classNames from 'classnames';
import { ReactComponent as RequestStatusIcon } from '@Icons/additional/desktop-status.svg';
import { ReactComponent as RequestNoIcon } from '@Icons/additional/desktop-request.svg';
import { ReactComponent as RequestDatesIcon } from '@Icons/additional/deskop-calendar.svg';
import { Col, Flex, Row, Typography } from 'antd';

import styles from './requisition-info.module.css';

interface RequisitionInfoProps {
  requisitionNo: number | string;
  requisitionDate: string;
  requisitionStatus: string;
}

const { Text } = Typography;

const RequisitionInformation: React.FC<RequisitionInfoProps> = ({
  requisitionNo = 0,
  requisitionDate = '',
  requisitionStatus,
}) => {
  return (
    <Flex
      className={classNames(
        styles.headerForm,
        'trojan-glassphormism-box trojan-glassphormism-box-shadow'
      )}
    >
      <Row wrap={false} className={styles.headerRowContainer}>
        <Col className={styles.headerContainer}>
          <Flex>
            <Flex align="center" vertical>
              <Flex>
                <div className={styles.svgContainer}>
                  <RequestNoIcon />
                </div>
              </Flex>
              <span className={styles.headerText}>Requisition No.</span>
              <Text
                title={String(requisitionNo)}
                className={styles.headerDataText}
                strong
              >
                {requisitionNo}
              </Text>
            </Flex>
          </Flex>
        </Col>
        <Col className={styles.headerContainer}>
          <Flex align="center">
            <Flex align="center" vertical>
              <Flex align="center">
                <div className={styles.svgContainer}>
                  <RequestDatesIcon />
                </div>
              </Flex>
              <span className={styles.headerText}>Requisition Date</span>
              <Text className={styles.headerDataText} strong>
                {requisitionDate}
              </Text>
            </Flex>
          </Flex>
        </Col>
        <Col className={styles.headerContainer}>
          <Flex align="center">
            <Flex align="center" vertical>
              <Flex align="center">
                <div className={styles.svgContainer}>
                  <RequestStatusIcon />
                </div>
              </Flex>
              <span className={styles.headerText}>Requisition Status</span>
              <Text className={styles.headerDataText} strong>
                {requisitionStatus}
              </Text>
            </Flex>
          </Flex>
        </Col>
      </Row>
    </Flex>
  );
};

export default RequisitionInformation;
